import LabelAndTextInput from '@components/inputs/LabelAndTextInput'
import RadioGroupAndLabel from '@components/radio/RadioGroupAndLabel'
import Title from '@components/title/Title'
import { setHasNotary, setCity, setName } from './notarySlice'
import { useAppDispatch, useAppSelector } from '@/hooks'
import type { RootState } from '@/store'
import { minLength2Validator, noNumberValidator, schemaValidator } from '@/utils/validators'
import type { FieldRules } from '../fieldRules'

import './Section.css'

interface NotaryProps {
	// What the schema says about each field.
	rules: FieldRules
	// The answers the whole form shares, for the schema's conditions.
	answers: Record<string, string>
}

function Notary(props: NotaryProps) {
	const dispatch = useAppDispatch()
	const { rules } = props
	// Whether the schema shows any of these questions for the answers so far.
	const hasField = (...keys: string[]) => keys.some(key => rules.shows(key, answers))

	const getHasNotary = useAppSelector((state: RootState) => state.notary.hasNotary)
	const onSetHasNotary = (value: string) => {
		dispatch(setHasNotary(value))
	}

	const getName = useAppSelector((state: RootState) => state.notary.name)
	const onSetName = (value: string) => {
		dispatch(setName(value))
	}

	const getCity = useAppSelector((state: RootState) => state.notary.city)
	const onSetCity = (value: string) => {
		dispatch(setCity(value))
	}

	const answers = { ...props.answers, hasNotary: getHasNotary }

	if (!hasField('hasNotary', 'notaryName', 'notaryCity')) {
		return null
	}

	return (
		<div className='section'>
			<Title>Votre notaire</Title>
			<div className='formContent'>
				{hasField('hasNotary') && (
					<div className='fieldLine'>
						<RadioGroupAndLabel
							id='hasNotary'
							label='Avez-vous un notaire ?'
							options={{ no: 'Non', yes: 'Oui' }}
							checked={getHasNotary}
							onChange={onSetHasNotary}
							validator={schemaValidator(rules.requires('hasNotary'))}
						/>
					</div>
				)}
				{hasField('notaryName', 'notaryCity') && (
						<div className='fieldLine'>
							{hasField('notaryName') && (
								<LabelAndTextInput
									id='notaryName'
									label='Nom du notaire'
									name='lastName'
									placeholder='Ex : Jean Dupont'
									value={getName}
									onChange={onSetName}
									validator={schemaValidator(rules.requires('notaryName'), minLength2Validator, noNumberValidator)}
									autocomplete='family-name'
								/>
							)}
							{hasField('notaryCity') && (
								<LabelAndTextInput
									id='notaryCity'
									label='Ville du notaire'
									name='city'
									placeholder='Ex : Paris'
									value={getCity}
									onChange={onSetCity}
									validator={schemaValidator(rules.requires('notaryCity'), minLength2Validator, noNumberValidator)}
									autocomplete='address-level2'
								/>
							)}
						</div>
					)}
			</div>
		</div>
	)
}

export default Notary
